// components/DashboardCom.js - Updated with CSS
import React, { useEffect, useState } from "react";
import Card from "../ReusableComponent/Card";
import "../../styles/dashbord.css";
import ReusableChart from "../ReusableComponent/Chart";
import { dashboard } from "../../util/Apiendpoits";
import { getWithTokenAPI } from "../../util/Api";
import { useSelector } from "react-redux";
import filter from "../../assets/filtericon.svg";
import {
  CardSkeleton,
  ChartSkeleton,
} from "../ReusableComponent/TableSkeleton";
import { Filter, X } from "lucide-react";
const DashboardCom = () => {
  const [rawData, setRawData] = useState([]);
  const currentYear = new Date().getFullYear();
  const minYear = 2026;
  const maxYear = currentYear + 1;
  const filters = {
    months: [
      { value: "", label: "All Months" },
      { value: "01", label: "January" },
      { value: "02", label: "February" },
      { value: "03", label: "March" },
      { value: "04", label: "April" },
      { value: "05", label: "May" },
      { value: "06", label: "June" },
      { value: "07", label: "July" },
      { value: "08", label: "August" },
      { value: "09", label: "September" },
      { value: "10", label: "October" },
      { value: "11", label: "November" },
      { value: "12", label: "December" },
    ],
    years: [
      { value: "", label: "All Years" },
      ...Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
        const year = maxYear - i; // descending order
        return {
          value: String(year),
          label: String(year),
        };
      }),
    ],
  };
  const [selectedMonth, setSelectedMonth] = useState("01");
  const [selectedYear, setSelectedYear] = useState("2026");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token, roleType } = useSelector((state) => state.auth);
  const [cardsData, setCardsData] = useState([]);
  const formatINR = (amount = 0) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const buildCardsData = (data) => [
    {
      filterKey: "students",
      title: "Total Students",
      value: data?.totalStudents?.count ?? 0,
      change: data?.totalStudents?.change?.split(" ")[0] || "0%",
      changeType: data?.totalStudents?.change?.includes("Up") ? "up" : "down",
      changeText: data?.totalStudents?.change || "",
      icon: "users",
      color: "blue",
      to: "/students",
    },
    {
      filterKey: "institutions",
      title: "Total Institutions",
      value: data?.totalInstitutions?.count ?? 0,
      change: data?.totalInstitutions?.change?.split(" ")[0] || "0%",
      changeType: data?.totalInstitutions?.change?.includes("Up")
        ? "up"
        : "down",
      changeText: data?.totalInstitutions?.change || "",
      icon: "school",
      color: "green",
      to: "/institutions",
    },
    {
      filterKey: "states",
      title: "States",
      value: data?.totalStates?.count ?? 0,
      change: data?.totalStates?.key || "",
      changeType: "neutral",
      changeText: "",
      icon: "map",
      color: "orange",
      to: "/",
    },
    {
      filterKey: "revenue",
      title: "Revenue",
      value: formatINR(data?.revenue?.total ?? 0),
      change: data?.revenue?.change?.split(" ")[0] || "0%",
      changeType: data?.revenue?.change?.includes("Up") ? "up" : "down",
      changeText: data?.revenue?.change || "",
      icon: "dollar",
      color: "purple",
      to: "/",
    },
  ];

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(token, dashboard);
      if (res?.success) {
        setCardsData(buildCardsData(res.data));
      } else {
        console.error("Failed to fetch dashboard data");
      }
    } catch (error) {
      console.error("Dashboard API error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchChartData = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        `/admin/dashboard/student-login-stats?year=${selectedYear}&month=${selectedMonth}`,
      );

      const apiData = res?.data; // ⭐ IMPORTANT
      console.log(res?.data?.days, "RESDAYS");
      // DAY-WISE
      if (selectedMonth !== "" && apiData?.days) {
        setRawData(
          apiData.days.map((item) => ({
            x: item.day,
            count: item.totalStudents,
          })),
        );
        return;
      }

      // MONTH-WISE
      if (selectedMonth === "" && Array.isArray(apiData)) {
        setRawData(
          apiData.map((item) => ({
            x: item.month,
            count: item.totalStudents,
          })),
        );
        return;
      }

      setRawData([]);
    } catch (error) {
      console.error("Chart fetch error:", error);
      setRawData([]);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchDashboardData();
    fetchChartData();
  }, [token, selectedMonth, selectedYear]);
  const [open, setOpen] = useState(false);

  const [filtersview, setFilters] = useState({
    students: true,
    institutions: true,
    states: true,
    revenue: true,
  });

  console.log(filtersview, "filtersviewfiltersview");

  const handleChange = (key) => {
    setFilters((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <h1 className="page-title">
          Dashboard
          <div className="filter-icon" onClick={() => setOpen(true)}>
            <img src={filter}></img>
          </div>
        </h1>
      </div>

      {open && (
        <div className="filter-overlay">
          <div className="filter-dialog">
            <div className="filter-header">
              <h3>Dashboard Filters</h3>
              <X onClick={() => setOpen(false)} />
            </div>

            <div className="filter-body">
              <label>
                <input
                  type="checkbox"
                  checked={filtersview.students}
                  onChange={() => handleChange("students")}
                />
                Total Students
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.institutions}
                  onChange={() => handleChange("institutions")}
                />
                Total Institutions
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.states}
                  onChange={() => handleChange("states")}
                />
                States
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.revenue}
                  onChange={() => handleChange("revenue")}
                />
                Revenue
              </label>
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <>
          {/* Stats Cards Grid Skeleton */}
          <div className="dashboard-grid-shimmer">
            {["blue", "green", "orange", "purple"].map((color, index) => (
              <CardSkeleton key={index} color={color} />
            ))}
          </div>

          {/* Chart Area Skeleton */}
          <div className="graph-wrapper-shimmer">
            <ChartSkeleton />
          </div>
        </>
      ) : (
        <>
          <div className="dashboard-grid">
            {cardsData
              .filter((card) => filtersview[card.filterKey])
              .map((card, index) => (
                <Card
                  key={index}
                  title={card.title}
                  value={card.value}
                  change={card.change}
                  changeType={card.changeType}
                  changeText={card.changeText}
                  icon={card.icon}
                  color={card.color}
                  navito={card.to}
                />
              ))}
          </div>

          <ReusableChart
            rawData={rawData}
            title="Log In Details"
            filters={filters}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
          />
        </>
      )}
    </div>
  );
};

export default DashboardCom;
